module.exports = __webpack_public_path__ + "static/media/aosept.04c796b4.png";